import { render, staticRenderFns } from "./New-Operator.vue?vue&type=template&id=47c69f86&"
import script from "./New-Operator.vue?vue&type=script&lang=ts&"
export * from "./New-Operator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports